import BoxedArrowLink from './BoxedArrowLink';

export default BoxedArrowLink;
